import { EmailService } from "./email-service/email.service";
import { MessageService } from "primeng/api";
import { Component, OnInit } from "@angular/core";

interface Autenticacoes {
  name: string;
  code: string;
}

@Component({
  selector: "app-cadastrar-email",
  templateUrl: "./cadastrar-email.component.html",
  styleUrls: ["./cadastrar-email.component.css"],
})
export class CadastrarEmailComponent implements OnInit {
  salvarCancelarEmail: boolean;
  salvarCancelarParam: boolean;
  editarEmailVisivel: boolean;
  editarParamVisivel: boolean;
  habilitar: boolean = true;
  habilitarEmail: boolean = true;
  tipoVisualizacao: string = "password";
  checkbox: any = {};
  public model: any = {};
  dadosParametrosSeguranca: any;
  autenticacoes: Autenticacoes[];
  selectedAutenticacao: Autenticacoes;

  constructor(
    private service: EmailService,
    private messageService: MessageService
  ) {
    this.autenticacoes = [
      { name: "Nenhum", code: "Nenhum" },
      { name: "StartTLS", code: "mail.smtp.startssl.enable" },
    ];
  }

  ngOnInit() {
    this.getParamSeguranca();
    this.editarEmailVisivel = true;
    this.editarParamVisivel = true;
  }

  salvarParametros() {
    let conjunto = [
      this.model.username,
      this.model.password,
      this.model.host,
      this.model.porta,
    ];
    if (
      this.checkbox.authentic &&
      (conjunto.every((item) => item === "") ||
        conjunto.some((item) => item === ""))
    ) {
      this.messageService.add({
        severity: "error",
        summary: "Erro ao salvar",
        detail:
          "É necessário que todos os campos de CADASTRO DE REMETENTE PARA ENVIO DE EMAIL estejam preenchidos se quiser usar a Autenticação de Dois Fatores.",
      });
    } else {
      this.editarParamVisivel = true;
      this.salvarCancelarParam = false;
      this.habilitar = true;
      const body = `&diasExpirarSenha=${this.model.day}&politica=${this.checkbox.politics}&expiracao=${this.checkbox.expire}&caracter=${this.checkbox.especialChars}&tamanhoLetra=${this.checkbox.letters}&numero=${this.checkbox.numbers}&autenticarDoisFatores=${this.checkbox.authentic}&diasExpirarConfiabilidade=${this.model.expiracao}`;
      this.service.salvarParametroSeguranca(body);

      this.messageService.add({
        severity: "success",
        summary: "Salvo",
        detail: "Salvo com Sucesso",
      });
    }
  }

  salvarEmail() {
    this.editarEmailVisivel = true;
    this.salvarCancelarEmail = false;
    this.habilitarEmail = true;

    this.service.cadastroEmail(
      this.model.username,
      this.model.password,
      this.model.host,
      this.model.porta,
      this.selectedAutenticacao.code
    );

    this.messageService.add({
      severity: "success",
      summary: "Salvo",
      detail: "Salvo com Sucesso",
    });
  }

  public habilitaTodasPoliticas(event: any) {
    if (this.checkbox.all) {
      this.checkbox.especialChars = true;
      this.checkbox.letters = true;
      this.checkbox.numbers = true;
    } else {
      this.checkbox.especialChars = false;
      this.checkbox.letters = false;
      this.checkbox.numbers = false;
    }
  }

  public ocultarDiv(event: any) {
    if (!this.checkbox.politics) {
      document.getElementById("divOculta").style.display = "none";
    } else {
      document.getElementById("divOculta").style.display = "block";
    }

    if (!this.checkbox.expire) {
      document.getElementById("divExpirarSenha").style.display = "none";
    } else {
      document.getElementById("divExpirarSenha").style.display = "block";
    }
  }

  enviarEmailTeste() {
    this.service
      .testarParametrosEmail(
        this.model.username,
        this.model.password,
        this.model.host,
        this.model.porta,
        this.selectedAutenticacao.code
      )
      .catch((erro) => this.tratarCodigoErro(erro));
  }

  tratarCodigoErro(erro) {
    if (erro.status === 501) {
      this.messageService.add({
        severity: "error",
        summary: "Email não Enviado",
        detail:
          "Ao tentar realizar um envio para o endereço de email, o provedor de destino respondeu que a conta de email é inexistente",
      });
    } else if (erro.status === 200) {
      this.messageService.add({
        severity: "success",
        summary: "Sucesso",
        detail: "Email enviado, verifique sua caixa de Email",
      });
    }
  }

  habilitarTodos(event: any) {
    if (
      this.checkbox.especialChars &&
      this.checkbox.letters &&
      this.checkbox.numbers
    ) {
      this.checkbox.all = true;
    } else {
      this.checkbox.all = false;
    }
  }

  cancelar() {
    this.editarParamVisivel = true;
    this.salvarCancelarParam = false;
    this.habilitar = true;

    this.getParamSeguranca();
  }

  cancelarEmail() {
    this.editarEmailVisivel = true;
    this.salvarCancelarEmail = false;
    this.habilitarEmail = true;

    this.getParamSeguranca();
  }

  revogarAcesso() {
    this.service.retirarAcesso();
    this.messageService.add({
      severity: "success",
      summary: "Revogado",
      detail: "Todos os acessos foram revogados",
    });
  }

  getParamSeguranca() {
    this.service.getTelaParam().subscribe({
      next: (res: any) => {
        this.dadosParametrosSeguranca = res;

        this.model.day = this.dadosParametrosSeguranca.diasExpirarSenha;
        this.model.expiracao = this.dadosParametrosSeguranca.diasExpirarConfiabilidade;
        this.model.username = this.dadosParametrosSeguranca.emailFabrica;
        this.model.host = this.dadosParametrosSeguranca.hostFabrica;
        this.model.password = this.dadosParametrosSeguranca.senhaFabrica;
        this.model.porta = this.dadosParametrosSeguranca.portaFabrica;
        this.selectedAutenticacao = this.autenticacoes.find(
          (autenticacoes) =>
            autenticacoes.code ===
            this.dadosParametrosSeguranca.tipoAutenticacao
        );
        this.checkbox = {
          expire: this.dadosParametrosSeguranca.expiracaoSenha,
          politics: this.dadosParametrosSeguranca.politicaSenha,
          especialChars: this.dadosParametrosSeguranca.caracterExpecial,
          letters: this.dadosParametrosSeguranca.maiusculoMinusculo,
          numbers: this.dadosParametrosSeguranca.numeros,
          authentic: this.dadosParametrosSeguranca.autenticarDoisFatores,
          all: false,
        };

        if (this.dadosParametrosSeguranca.politicaSenha) {
          document.getElementById("divOculta").style.display = "block";
        } else {
          document.getElementById("divOculta").style.display = "none";
        }

        if (this.dadosParametrosSeguranca.expiracaoSenha) {
          document.getElementById("divExpirarSenha").style.display = "block";
        } else {
          document.getElementById("divExpirarSenha").style.display = "none";
        }

        if (
          this.checkbox.especialChars &&
          this.checkbox.letters &&
          this.checkbox.numbers
        ) {
          this.checkbox.all = true;
        } else {
          this.checkbox.all = false;
        }
      },
    });
  }
}
